import { useState } from "react";
import useAuthentication from "../../hooks/auth";

import { BarsIcon } from "../../assets/icons";
import profilePic from "../../assets/images/profile-pic.png";
import { IconButton } from "../IconButton";
import "./TopDetailBar.scss";

/**
 * TopDetailBar component
 * @param {{
 *   onNavExpand: () => void
 * }} props
 * @returns {JSX.Element} TopDetailBar
 */

function getMonthName(month) {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return monthNames[month];
}

function getOrdinalSuffix(day) {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

function TopDetailBar({ onNavExpand }) {
  const date = new Date();
  const [time, setTime] = useState(date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
  const { profile } = useAuthentication();

  setInterval(() => {
    setTime(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
  }, 1000);

  return (
    <div className="top-detail-bar">
      <div className="left-content">
        <div className="nav-toggler">
          <IconButton onClick={onNavExpand} icon={<BarsIcon />} outlined />
        </div>

        <div className="clock">
          <div className="time">
            <span>{time}</span>
          </div>

          <div className="date">
            <span>
              {date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}<sup>{getOrdinalSuffix(date.getDate())}</sup> of {getMonthName(date.getMonth())}, {date.getFullYear()}
            </span>
          </div>
        </div>
      </div>

      <div className="profile">
        <div className="profile-pic">
          <img src={profilePic} alt="Profile Pic" />
        </div>
        <div className="details">
          <span className="name">{profile?.firstName} {profile?.lastName}</span>
          <span className="role">{profile?.role}</span>
        </div>
      </div>
    </div>
  );
}

export default TopDetailBar;
